import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-163">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-164">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-slate-200" data-id="element-165">
          <h2 id="modal-title" className="text-xl font-bold text-navy-900 pr-8" data-id="element-166">
            {title}
          </h2>
          <button onClick={onClose} aria-label="Cerrar" className="flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-navy-900 transition-colors" data-id="element-167">
            <X className="w-5 h-5" data-id="element-168" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6 overflow-y-auto text-slate-600 leading-relaxed" data-id="element-169">
          {children}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-100 bg-slate-50 flex justify-end" data-id="element-170">
          <button onClick={onClose} className="px-5 py-2 bg-navy-900 hover:bg-navy-800 text-white text-sm font-bold rounded-md transition-colors" data-id="element-171">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}